import React from 'react'
import { Text, View } from 'react-native'
import { tv } from 'tailwind-variants'

import { Checkbox as UiKitCheckbox } from '@ui-kit/components/formComponents/Checkbox'
import { body2, caption } from '@ui-kit/core/typography'

const checkbox = tv({
  slots: {
    container: 'mb-2 flex-row items-start gap-3',
    box: 'mt-0.5',
    label: 'flex-1',
  },
  variants: {
    hasSubtitle: {
      true: { label: body2({ bold: true }) },
      false: { label: caption() },
    },
  },
  defaultVariants: { hasSubtitle: false },
})

export const Checkbox = ({
  checked,
  onPress,
  children,
  hasError,
  hasSubtitle,
  testID,
}: {
  checked: boolean
  onPress: () => void
  children: React.ReactNode
  hasError?: boolean
  hasSubtitle?: boolean
  testID?: string
}) => {
  const styles = checkbox({ hasSubtitle })

  return (
    <View className={styles.container()}>
      <View className={styles.box()}>
        <UiKitCheckbox
          isChecked={checked}
          hasError={hasError}
          testID={testID}
          onPress={() => onPress()}
        />
      </View>
      <Text className={styles.label()} onPress={onPress}>
        {children}
      </Text>
    </View>
  )
}
